// @ts-nocheck
import { getCurrentAccountState } from "@insite/client-framework/Store/Data/Accounts/AccountsSelector";
import {
    chain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/SaveCurrentAccount";
import { addToChainAfter, createChainHandler } from "@toolkit/Modules/client-framework/HandlerCreator";

export const PopulateAdditionalApiParameter = createChainHandler("PopulateApiParameter", chain, props => {
    const greifState = props.getState().greif.pages.accountSettings;
    const jsonResponse = {
        followNewPrice: greifState.followNewPrice,
        followNewTec: greifState.followNewTec,
        followNewFeature: greifState.followNewFeature,
        followUpcomingShipment: greifState.followUpcomingShipment,
        followOrderShipped: greifState.followOrderShipped,
        followOrderPickup: greifState.followOrderPickup,
        followOrderChange: greifState.followOrderChange,
    };

    props.apiParameter = {
        ...props.apiParameter,
        account: {
            ...props.account,
            properties: {
                notificationsFollowed: JSON.stringify(jsonResponse),
                communicationLanguageId: greifState.language,
            },
        },
    };
});

addToChainAfter(chain, PopulateApiParameter, PopulateAdditionalApiParameter);
